// extracted by mini-css-extract-plugin
export default {"root":"qPlCruTsns","root_widthConstrained":"Hoe52fXYCj","root_noPadding":"_6TiLtZc_w","divider":"AZRHMRFFMB"};